<app-extramural-care-list [folderId]="folderId"></app-extramural-care-list>
